var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 38,
    viewBox: "0 0 112 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4029 6.36426L0 28.7672H11.2014L13.9982 25.9704H33.6043L27.9964 20.3769H19.6061L28.0108 11.9722L22.4029 6.36426Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4028 6.36426L16.8093 11.9578L33.6043 28.7527H44.8057L22.4028 6.36426Z",
    fill: "#2A2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6008 0.770508L50.3993 11.9719L44.8058 6.37843H33.6043L44.8058 17.5798L25.142 37.2292H36.3434L50.3993 23.1734L55.9928 28.7669H67.1943L55.9928 17.5654L72.8022 0.770508H61.6008Z",
    fill: "#2A2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4101 6.36426L56.0072 28.7672H67.2087L78.4101 17.5657L89.6116 28.7672L112 6.36426H100.799L89.5972 17.5657L78.4101 6.36426Z",
    fill: "#2A2A2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0054 28.7671H86.8004L78.4101 20.3768L70.0054 28.7671Z",
    fill: "#2A2A2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2068 28.7671H86.8003L78.4101 20.3768L81.2068 28.7671Z",
    fill: "#2A2A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwx);
export default __webpack_public_path__ + "static/media/awx.41627df903844d32a52b740afe7fcd02.svg";
export { ForwardRef as ReactComponent };